var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcAddCircle = function SvgIcAddCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M10 3a7 7 0 1 1 0 14 7 7 0 0 1 0-14zm0 1.436a5.564 5.564 0 1 0 0 11.128 5.564 5.564 0 0 0 0-11.128zm0 2.782c.397 0 .718.321.718.718l-.001 1.346h1.347a.718.718 0 0 1 .098 1.43l-.098.006-1.347-.001v1.347c0 .364-.27.664-.62.711l-.097.007a.718.718 0 0 1-.718-.718v-1.347H7.936a.718.718 0 0 1-.098-1.428l.098-.007h1.346V7.936c0-.364.27-.664.62-.711z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9cc100",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcAddCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-add-circle.6886833d7f590717dfaac182a385bd1c.svg";